import type { GetBannersParams } from '../__generated__/gateway/gatewayApiTypes';
import { SravniReviewsEnumsReviewObjectType } from '../__generated__/reviews/reviewsApiTypes';

export enum OrganizationType {
  BANK = SravniReviewsEnumsReviewObjectType.Banks,
  INSURANCE = SravniReviewsEnumsReviewObjectType.InsuranceCompany,
  MFI = SravniReviewsEnumsReviewObjectType.Mfi,
  COURSES = SravniReviewsEnumsReviewObjectType.EducationalOrganization,
  BROKER = SravniReviewsEnumsReviewObjectType.Broker,
  NPF = SravniReviewsEnumsReviewObjectType.Npf,
  LEASING = SravniReviewsEnumsReviewObjectType.Leasing,
  MARKETPLACE = SravniReviewsEnumsReviewObjectType.Marketplace,
  BANKRUPTCY = SravniReviewsEnumsReviewObjectType.Bankruptcy,
  UNIVERSITY = SravniReviewsEnumsReviewObjectType.University,
  BOOKMAKER = SravniReviewsEnumsReviewObjectType.Bookmaker,
  FOOD_RATION = SravniReviewsEnumsReviewObjectType.FoodRation,
}

export enum OrganizationTypeForService {
  BANK = 'bank',
  INSURANCE = 'insurance',
  MFO = 'mfo',
  EDUCATIONAL_ORGANIZATION = 'educationalOrganization',
  Broker = 'broker',
  NPF = 'npf',
  LEASING = 'leasing',
  MARKETPLACE = 'marketplace',
  BANKRUPTCY = 'bankruptcy',
  UNIVERSITY = 'university',
  BOOKMAKER = 'bookmaker',
  FOOD_RATION = 'foodRation',
}

export const PAGE_ROUTE_TO_ORGANIZATION_TYPE_MAP: Record<string, OrganizationType> = {
  'strakhovye-kompanii': OrganizationType.INSURANCE,
  banki: OrganizationType.BANK,
  zaimy: OrganizationType.MFI,
  kursy: OrganizationType.COURSES,
  brokery: OrganizationType.BROKER,
  npf: OrganizationType.NPF,
  leasing: OrganizationType.LEASING,
  marketplace: OrganizationType.MARKETPLACE,
  bankruptcy: OrganizationType.BANKRUPTCY,
  university: OrganizationType.UNIVERSITY,
  bukmekery: OrganizationType.BOOKMAKER,
  'raciony-kompanii': OrganizationType.FOOD_RATION,
};

export const ORGANIZATION_TYPE_TO_HEADER_MAP: Record<OrganizationType, string> = {
  [OrganizationType.BANK]: 'банков',
  [OrganizationType.INSURANCE]: 'страховых компаний',
  [OrganizationType.MFI]: 'микрофинансовых организаций',
  [OrganizationType.COURSES]: 'образовательных организаций',
  [OrganizationType.BROKER]: 'брокеров',
  [OrganizationType.NPF]: 'негосударственных пенсионных фондов',
  [OrganizationType.LEASING]: 'лизинговых компаний',
  [OrganizationType.MARKETPLACE]: 'сервисов для маркетплейсов',
  [OrganizationType.BANKRUPTCY]: 'компаний по банкротству',
  [OrganizationType.UNIVERSITY]: 'ВУЗов',
  [OrganizationType.BOOKMAKER]: 'букмекеров',
  [OrganizationType.FOOD_RATION]: 'сервисов готовых рационы',
};

export const OrganizationTypeToOrganizationReviewsMap: Record<OrganizationType, string> = {
  [OrganizationType.BANK]: 'bank',
  [OrganizationType.INSURANCE]: 'strakhovaja-kompanija',
  [OrganizationType.MFI]: 'zaimy/mfo',
  [OrganizationType.COURSES]: 'shkola',
  [OrganizationType.BROKER]: 'broker',
  [OrganizationType.NPF]: 'npf',
  [OrganizationType.LEASING]: 'leasing',
  [OrganizationType.MARKETPLACE]: 'marketplace',
  [OrganizationType.BANKRUPTCY]: 'bankruptcy',
  [OrganizationType.UNIVERSITY]: 'university',
  [OrganizationType.BOOKMAKER]: 'bukmeker',
  [OrganizationType.FOOD_RATION]: 'raciony-kompanii',
};

export const OrganizationTypeToReviewsServiceMap: Record<OrganizationType, string> = {
  [OrganizationType.BANK]: 'bank',
  [OrganizationType.INSURANCE]: 'insuranceCompany',
  [OrganizationType.MFI]: 'mfo',
  [OrganizationType.COURSES]: 'educationalOrganization',
  [OrganizationType.BROKER]: 'broker',
  [OrganizationType.NPF]: 'npf',
  [OrganizationType.LEASING]: 'leasing',
  [OrganizationType.MARKETPLACE]: 'marketplace',
  [OrganizationType.BANKRUPTCY]: 'bankruptcy',
  [OrganizationType.UNIVERSITY]: 'university',
  [OrganizationType.BOOKMAKER]: 'bookmaker',
  [OrganizationType.FOOD_RATION]: 'foodRation',
};

export const OrganizationTypeToOrganizationServiceMap: Record<OrganizationType, string> = {
  [OrganizationType.BANK]: 'bank',
  [OrganizationType.INSURANCE]: 'insurance',
  [OrganizationType.MFI]: 'mfo',
  [OrganizationType.COURSES]: 'educationalOrganization',
  [OrganizationType.BROKER]: 'broker',
  [OrganizationType.NPF]: 'npf',
  [OrganizationType.LEASING]: 'leasing',
  [OrganizationType.MARKETPLACE]: 'marketplace',
  [OrganizationType.BANKRUPTCY]: 'bankruptcy',
  [OrganizationType.UNIVERSITY]: 'university',
  [OrganizationType.BOOKMAKER]: 'bookmaker',
  [OrganizationType.FOOD_RATION]: 'foodRation',
};

export const OrganizationTypeToGatewayServiceMap = {
  [OrganizationType.BANK]: 'banks' as GetBannersParams['Category'],
  [OrganizationType.INSURANCE]: 'insurance' as GetBannersParams['Category'],
  [OrganizationType.MFI]: 'banks' as GetBannersParams['Category'],
  [OrganizationType.COURSES]: 'none' as GetBannersParams['Category'],
  [OrganizationType.BROKER]: 'banks' as GetBannersParams['Category'],
  [OrganizationType.NPF]: 'banks' as GetBannersParams['Category'],
  [OrganizationType.LEASING]: 'none' as GetBannersParams['Category'],
  [OrganizationType.MARKETPLACE]: 'none' as GetBannersParams['Category'],
  [OrganizationType.BANKRUPTCY]: 'none' as GetBannersParams['Category'],
  [OrganizationType.UNIVERSITY]: 'none' as GetBannersParams['Category'],
  [OrganizationType.BOOKMAKER]: 'none' as GetBannersParams['Category'],
  [OrganizationType.FOOD_RATION]: 'none' as GetBannersParams['Category'],
};

export const ReviewObjectTypeToOrganizationType = {
  [SravniReviewsEnumsReviewObjectType.Banks]: OrganizationType.BANK,
  [SravniReviewsEnumsReviewObjectType.InsuranceCompany]: OrganizationType.INSURANCE,
  [SravniReviewsEnumsReviewObjectType.Mfi]: OrganizationType.MFI,
  [SravniReviewsEnumsReviewObjectType.Broker]: OrganizationType.BROKER,
  [SravniReviewsEnumsReviewObjectType.EducationalOrganization]: OrganizationType.COURSES,
  [SravniReviewsEnumsReviewObjectType.Npf]: OrganizationType.NPF,
  [SravniReviewsEnumsReviewObjectType.Leasing]: OrganizationType.LEASING,
  [SravniReviewsEnumsReviewObjectType.Marketplace]: OrganizationType.MARKETPLACE,
  [SravniReviewsEnumsReviewObjectType.Bankruptcy]: OrganizationType.BANKRUPTCY,
  [SravniReviewsEnumsReviewObjectType.University]: OrganizationType.UNIVERSITY,
  [SravniReviewsEnumsReviewObjectType.Bookmaker]: OrganizationType.BOOKMAKER,
  [SravniReviewsEnumsReviewObjectType.FoodRation]: OrganizationType.FOOD_RATION,
};

export enum OrganizationStatuses {
  ACTIVE = 'active',
  HIDDEN = 'hidden',
  ARCHIVED = 'archived',
  ABSORBED = 'absorbed',
}
